import SpeedometerModel from './speedometer-model'
import createWob from '../create-wob'
import ScorecardNode from '../../../scorecards/scorecard-node'
import AddDomainObjectEndpoint
	from '../../../components/bootslide/add-domain-object-endpoint'
import _ from 'lodash'
import { DATA_SOURCE_PROPERTY } from '../shape/shape-widget-properties'
const { metricish } = ScorecardNode

const SpeedometerAddOption = AddDomainObjectEndpoint.extend({

	selectorOptions: function(opt) {
		var selectorOpts = AddDomainObjectEndpoint.prototype.selectorOptions.apply(this, arguments)

		return _.extend(selectorOpts, {
			params: {
				// need the source type so I can give linked metrics appropriate defaults
				// TODO only if this.section === 'scorecards'
				sourceType: true
			}
		})
	},

	add: function (node) {
		var isMetric = metricish(node)

		let properties = _.extend(
			{},
			DEFAULT_SPEEDOMETER_PROPERTIES,
			{
				section: this.section,
				domainObjectId: node.id,
				showChange: isMetric
			})

		if (isMetric) {
			properties.thresholdMode = 'none'
		}

		if (this.section === 'initiatives') {
			properties[DATA_SOURCE_PROPERTY] = 'percent-complete'
		}

		var widget = new SpeedometerModel({ properties }, {
			domainObject: node
		})

		createWob(this.canvas, widget, { fetchData: true }, this.bootslideMenu)
	}

})

const DEFAULT_SPEEDOMETER_PROPERTIES = {
	type: 'speedometer',
	showLabel: true,
	periodDelta: '0',
	drilldownSection: 'default',
	showActual: true
}

export default SpeedometerAddOption
export { DEFAULT_SPEEDOMETER_PROPERTIES }

SpeedometerAddOption.__filename__ = 'dashboards/widgets/speedometer/speedometer-add-option.js'
